<template>
  <px-lateral-dialog v-model="dialog"
                     width="600">
    <template v-slot:activator="{ on }">
      <v-btn x-small class="ml-3" color="primary" v-on="on" v-if="!hasSelectedAddress">
        Escolher endereço
      </v-btn>
      <v-btn x-small class="ml-3" color="error" v-else @click="onClickRemove">
        Remover seleção
      </v-btn>
    </template>
    <template v-slot:title>
      Endereços para {{ cep | cep }}
    </template>
    <template>
      <div v-if="loading">
        <px-circular-loading/>
      </div>
      <div v-if="!loading && !locais.content.length"
           align="center"
           class="headline mb-5 mt-5">
        Nenhum endereço encontrado para o CEP
      </div>
      <v-card outlined v-if="!loading && locais.content.length">
        <v-radio-group class="mt-0 pt-0" hide-details v-model="selected">
          <v-list>
            <template v-for="(local, index) in locais.content">
              <v-list-item :key="local.id" class="mt-2 mb-2">
                <v-radio class="mt-2" :value="local">
                  <template v-slot:label>
                    <div class="d-inline-block ml-2">
                      <px-endereco-cpf-cnpj :local="local.localFrete"
                                            :municipio="local.municipio"/>
                    </div>
                  </template>
                </v-radio>
              </v-list-item>
              <v-divider :key="`div-${local.id}`" v-if="index < locais.content.length - 1"/>
            </template>
          </v-list>
        </v-radio-group>
      </v-card>
    </template>
    <template v-slot:actions>
      <v-spacer/>
      <v-btn @click="close">
        Cancelar
      </v-btn>
      <v-btn color="primary"
             :disabled="!selected"
             @click="selecionar">
        Selecionar
      </v-btn>
    </template>
  </px-lateral-dialog>
</template>

<script>
import { onlyNumbers } from '@/utils/regex-utils';
import ContratacaoFreteService from './contratacao-frete-service';

export default {
  props: {
    cep: String,
    hasSelectedAddress: Boolean,
  },
  data() {
    return {
      locais: {
        content: [],
        total: 0,
      },
      selected: null,
      dialog: false,
      loading: false,
    };
  },
  methods: {
    selecionar() {
      this.$emit('change', this.selected);
      this.close();
    },
    onClickRemove() {
      this.$emit('clear');
    },
    close() {
      this.dialog = false;
    },
    setup() {
      this.selected = null;
      this.loading = true;
      ContratacaoFreteService.locaisFavoritos({
        query: `cep = "${onlyNumbers(this.cep)}"`,
      })
        .then(({ data }) => {
          this.locais = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    dialog(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (newValue) {
        this.setup();
      }
    },
  },
};
</script>
